import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyPL() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Powrót do aplikacji
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Polityka prywatności</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Administrator danych osobowych</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Administratorem danych osobowych jest:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Nazwa:</strong> Puretech s.r.o.</p>
                  <p><strong>IČO:</strong> 05503795</p>
                  <p><strong>Siedziba:</strong> Republika Czeska</p>
                  <p><strong>Kontakt:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informacje, które gromadzimy</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Informacje o koncie:</strong> Kiedy tworzysz konto, gromadzimy Twój adres e-mail oraz wszelkie informacje profilowe, które zdecydujesz się podać.
                </p>
                <p className="leading-relaxed">
                  <strong>Dane dotyczące użytkowania:</strong> Gromadzimy informacje o tym, jak korzystasz z naszej usługi, w tym utworzone zadania, zarządzane projekty oraz wzorce korzystania z funkcji.
                </p>
                <p className="leading-relaxed">
                  <strong>Informacje płatnicze:</strong> Przetwarzanie płatności jest obsługiwane przez Polar. Nie przechowujemy danych Twojej karty płatniczej na naszych serwerach.
                </p>
                <p className="leading-relaxed">
                  <strong>Dane techniczne:</strong> Automatycznie gromadzimy pewne informacje techniczne, w tym adres IP, typ przeglądarki, system operacyjny i informacje o urządzeniu.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Jak wykorzystujemy Twoje informacje</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Wykorzystujemy zebrane informacje do:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Świadczenia, utrzymania i ulepszania naszych usług</li>
                  <li>Przetwarzania transakcji i zarządzania subskrypcjami</li>
                  <li>Wysyłania powiadomień technicznych i wiadomości wsparcia</li>
                  <li>Odpowiadania na Twoje komentarze i pytania</li>
                  <li>Analizy wzorców użytkowania w celu poprawy doświadczenia użytkownika</li>
                  <li>Egzekwowania naszych warunków usługi</li>
                  <li>Przestrzegania obowiązków prawnych</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Udostępnianie informacji</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nie sprzedajemy, nie handlujemy ani w inny sposób nie przekazujemy Twoich danych osobowych stronom trzecim, z wyjątkiem przypadków opisanych w niniejszej polityce:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dostawcy usług:</strong> Możemy udostępniać informacje zaufanym stronom trzecim, które pomagają nam prowadzić naszą usługę (np. Polar do przetwarzania płatności, Supabase do usług bazodanowych)</li>
                  <li><strong>Wymogi prawne:</strong> Możemy ujawnić informacje, jeśli wymagane jest to przez prawo lub w celu ochrony naszych praw</li>
                  <li><strong>Przejęcia firmowe:</strong> W przypadku fuzji, przejęcia lub sprzedaży aktywów, informacje użytkowników mogą zostać przekazane</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Bezpieczeństwo danych</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wdrażamy odpowiednie techniczne i organizacyjne środki bezpieczeństwa w celu ochrony Twoich danych osobowych przed nieautoryzowanym dostępem, zmianą, ujawnieniem lub zniszczeniem. Żadna metoda przesyłania danych przez Internet nie jest jednak w 100% bezpieczna.
                </p>
                <p className="leading-relaxed">
                  <strong>Naruszenie bezpieczeństwa:</strong> W przypadku naruszenia bezpieczeństwa danych osobowych będziemy postępować zgodnie z RODO:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Zgłosimy incydent odpowiedniemu organowi nadzorczemu w ciągu 72 godzin od jego wykrycia</li>
                  <li>Poinformujemy Cię, jeśli naruszenie może stanowić wysokie ryzyko dla Twoich praw i wolności</li>
                  <li>Podejmiemy kroki w celu zminimalizowania wpływu i zapobieżenia przyszłym incydentom</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Przechowywanie danych</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Przechowujemy Twoje dane osobowe tak długo, jak jest to konieczne do świadczenia naszych usług. Szczegółowe okresy przechowywania to:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dane konta:</strong> Przez okres istnienia Twojego konta + 30 dni po usunięciu konta</li>
                  <li><strong>Treść zadań (sticky notes):</strong> Dopóki ich nie usuniesz lub nie zlikwidujesz konta</li>
                  <li><strong>Zapisy płatności:</strong> 7 lat (wymóg czeskiej ustawy rachunkowej nr 563/1991 Sb.)</li>
                  <li><strong>Dane analityczne:</strong> Do 26 miesięcy</li>
                  <li><strong>Dane kopii zapasowych:</strong> Mogą być przechowywane do 90 dni po podstawowym usunięciu</li>
                  <li><strong>Dane zanonimizowane:</strong> Przechowujemy na stałe do celów statystycznych</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Twoje prawa zgodnie z RODO</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Masz prawo do:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Dostępu do danych osobowych, które o Tobie przechowujemy</li>
                  <li>Sprostowania wszelkich nieprawidłowych danych osobowych</li>
                  <li>Żądania usunięcia Twoich danych osobowych</li>
                  <li>Sprzeciwu lub ograniczenia przetwarzania Twoich danych</li>
                  <li>Przenoszalności danych (otrzymanie kopii Twoich danych w ustrukturyzowanym formacie)</li>
                  <li>Wycofania zgody w dowolnym momencie</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Pliki cookie i śledzenie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Używamy plików cookie i podobnych technologii śledzenia w celu poprawy Twojego doświadczenia. Rodzaje plików cookie, których używamy:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Niezbędne pliki cookie:</strong> Potrzebne do działania usługi (logowanie, uwierzytelnianie)</li>
                  <li><strong>Analityczne pliki cookie:</strong> Pomagają nam zrozumieć, jak korzystasz z naszej usługi (możesz odrzucić)</li>
                  <li><strong>Pliki cookie stron trzecich:</strong> Google OAuth, Polar do płatności</li>
                </ul>
                <p className="leading-relaxed">
                  Możesz kontrolować ustawienia plików cookie za pomocą preferencji przeglądarki lub naszego bannera cookie przy pierwszej wizycie.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Usługi stron trzecich</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Nasza usługa integruje się z usługami stron trzecich:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Do uwierzytelniania (podlega polityce prywatności Google)</li>
                  <li><strong>Polar:</strong> Do przetwarzania płatności (podlega polityce prywatności Polar)</li>
                  <li><strong>Supabase:</strong> Do usług bazodanowych i uwierzytelniania</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Ochrona prywatności dzieci</h2>
              <p className="leading-relaxed">
                Nasza usługa nie jest przeznaczona dla dzieci poniżej 16 roku życia. Świadomie nie gromadzimy danych osobowych od dzieci poniżej 16 roku życia. Jeśli jesteś rodzicem lub opiekunem i uważasz, że Twoje dziecko dostarczyło nam dane osobowe, skontaktuj się z nami pod adresem support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Międzynarodowe przekazywanie danych</h2>
              <p className="leading-relaxed">
                Twoje informacje mogą być przekazywane i przetwarzane w krajach innych niż kraj Twojego zamieszkania. Zapewniamy, że stosowane są odpowiednie zabezpieczenia w celu ochrony Twoich danych osobowych zgodnie z mającymi zastosowanie przepisami o ochronie danych.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Zmiany w niniejszej polityce</h2>
              <p className="leading-relaxed">
                Możemy od czasu do czasu aktualizować niniejszą politykę prywatności. Powiadomimy Cię o wszelkich istotnych zmianach, publikując nową politykę na tej stronie i aktualizując datę "Ostatnia aktualizacja".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Automatyczne podejmowanie decyzji</h2>
              <p className="leading-relaxed">
                Nasza usługa wykorzystuje algorytm AI do generowania sugestii zadań. Ta funkcja ma charakter czysto pomocniczy i nie tworzy żadnych decyzji, które miałyby skutki prawne lub istotne konsekwencje dla użytkowników. Możesz w każdej chwili zdecydować się nie korzystać z sugestii.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Organ nadzorczy</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Masz prawo złożyć skargę do organu nadzorczego ds. ochrony danych osobowych:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Urząd Ochrony Danych Osobowych (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Praga 7</p>
                  <p className="text-sm">Strona: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">E-mail: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Jak skorzystać ze swoich praw</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Aby skorzystać ze swoich praw wynikających z RODO (dostęp do danych, sprostowanie, usunięcie, przenoszalność, sprzeciw itp.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Wyślij nam żądanie na <strong>support@simplestickers.app</strong></li>
                  <li>Odpowiemy w ciągu <strong>1 miesiąca</strong> od otrzymania żądania</li>
                  <li>Możemy poprosić o weryfikację Twojej tożsamości</li>
                  <li>Usługa jest <strong>bezpłatna</strong> (o ile żądanie nie jest oczywiście bezzasadne lub nadmierne)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Skontaktuj się z nami</h2>
              <p className="leading-relaxed">
                Jeśli masz jakiekolwiek pytania dotyczące niniejszej polityki prywatności lub naszych praktyk dotyczących danych, skontaktuj się z nami:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>E-mail:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  W sprawie wszystkich pytań dotyczących prywatności, żądań dotyczących danych, wsparcia i innych zapytań
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
